import { render, staticRenderFns } from "./ys.vue?vue&type=template&id=bc4718fc&scoped=true"
import script from "./ys.vue?vue&type=script&lang=js"
export * from "./ys.vue?vue&type=script&lang=js"
import style0 from "./ys.vue?vue&type=style&index=0&id=bc4718fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4718fc",
  null
  
)

export default component.exports